export default "__VITE_ASSET__Yl_rSsBP__"